// @flow
import type Stopwatch from 'app/packages/trace-logger/Stopwatch';
import { DEBUG_ENABLED, DISABLE_TRACING } from 'app/packages/trace-logger/debugFlags';

const DEBUG_PERF_LOGGER_ENABLED = DEBUG_ENABLED || DISABLE_TRACING;

type WindowPerfLogger = {
  stopwatchList: Array<Stopwatch>,
};

export default function addStopwatchToDebugPerfLogger(stopwatch: Stopwatch) {
  if (__SERVER__ || !DEBUG_PERF_LOGGER_ENABLED) {
    return;
  }
  // The global var `window.PERF_LOGGER` is used in the PWT regression CI tests.
  // See http://opengrok.pinadmin.com/xref/Web-PWT-Regression-CI-Tests/helpers/pwtPuppeteerHelper.js
  const perfLogger: WindowPerfLogger = window.PERF_LOGGER || { stopwatchList: [] };
  window.PERF_LOGGER = perfLogger;
  perfLogger.stopwatchList.push(stopwatch);
}
